import script from "./WoononCompletionOneProductsMobile.vue?vue&type=script&lang=ts&setup=true"
export * from "./WoononCompletionOneProductsMobile.vue?vue&type=script&lang=ts&setup=true"

import "./WoononCompletionOneProductsMobile.vue?vue&type=style&index=0&id=4566be8e&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4566be8e"]])

export default __exports__